export const otsu = (values: number[]): number => {
  let min = Infinity;
  let max = -Infinity;
  for (const v of values) {
    if (v < min) min = v;
    if (v > max) max = v;
  }
  if (!(max > min)) return max;
  const bins = 64;
  const histogram = new Float64Array(bins);
  for (const v of values) histogram[Math.min(bins - 1, Math.floor(((v - min) / (max - min)) * bins))]++;
  let sumAll = 0;
  for (let i = 0; i < bins; i++) sumAll += i * histogram[i];
  let weightBelow = 0;
  let sumBelow = 0;
  let best = -1;
  let bestBin = 0;
  for (let i = 0; i < bins; i++) {
    weightBelow += histogram[i];
    sumBelow += i * histogram[i];
    if (weightBelow === 0) continue;
    const weightAbove = values.length - weightBelow;
    if (weightAbove === 0) break;
    const between =
      weightBelow * weightAbove * (sumBelow / weightBelow - (sumAll - sumBelow) / weightAbove) ** 2;
    if (between > best) {
      best = between;
      bestBin = i;
    }
  }
  return min + ((bestBin + 1) / bins) * (max - min);
};
